// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.RequestType in volt.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.EnumAdapter
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireEnum
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.JvmStatic
import kotlin.Int
import kotlin.Suppress

/**
 * Message request type
 *     GET - client is expecting a protobuf message response of the same type as \[MessageWrapper\] payload.
 *            with all required fields for target device to process the message. Payload needs to be set
 *            empty message to set the payload type.
 *     POST - client is not expecting a protobuf message response but provides a protobuf message as payload.
 *            with all required fields for target device to process the message.
 */
public enum class RequestType(
  override val `value`: Int,
) : WireEnum {
  GET(0),
  POST(1),
  ;

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<RequestType> = object : EnumAdapter<RequestType>(
      RequestType::class, 
      PROTO_3, 
      RequestType.GET
    ) {
      override fun fromValue(`value`: Int): RequestType? = RequestType.fromValue(`value`)
    }

    @JvmStatic
    public fun fromValue(`value`: Int): RequestType? = when (`value`) {
      0 -> GET
      1 -> POST
      else -> null
    }
  }
}
